import "./css/Modal.css"

export default function Modal(props : any) {

    function handleModalDialogClick(e: any) : void {
        e.stopPropagation();
    }

    return (
        <div className={`modal ${props.isOpen && 'modal-open'}`} onClick={props.closeModal}>
            <div className="modal__dialog" onClick={handleModalDialogClick}>
                <div className="modal__content_btn">
                    <button className="modal__btn-close" onClick={props.closeModal}>X</button>
                </div>
                <div className="modal__content">
                    {props.title && <h1 className="modal__h1">{props.title}</h1>}
                    {props.descript && <p className="modal__p">{props.descript}</p>}
                    {props.teamList &&
                        <div className="modal__teamList">
                        <p className="modal__team_title">Equipo</p>
                            {props.teamList?.map((team : any, i : number) => 
                                <a key={i} className="modal__team" href={team.href} target="_blank" rel="noreferrer noopener">
                                    - {team.name}
                                </a>                    
                            )}   
                    </div>}
                    {props.children}
                </div>
            </div>
        </div>
    )
}